<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { inject } from 'vue';
import { richTextToGovukHtml } from '/@src/utils/richTextToGovukHtml';

const { t } = useI18n()
const specResponse = inject('specResponse')
const instrukcieRozpoctu = specResponse?.zoppmSpec?.instrukcieRozpoctu
</script>

<template>
  <CanSkipWarningText v-if="$attrs.canSkip" />
  <IDSKHeading as="h1" variant="xl" class="mb-8">{{ t('zoppm.step9.mainHeading') }}</IDSKHeading>
  <div v-if="!$attrs.canSkip" v-html="richTextToGovukHtml(instrukcieRozpoctu)" class="mb-8" />
</template>


<style lang="scss">

</style>
